export const expandableData: Array<any> = [
  {
    name: 'deviceType',
    title: 'Device Type',
    getCellValue: (row: any) => row.deviceType,
  },
  {
    name: 'createdBy',
    title: 'Queued By',
    getCellValue: (row: any) => row.createdBy,
  },
  {
    name: 'telematicsAssetID',
    title: 'Telematics Asset ID',
    getCellValue: (row: any) => row.telematicsAssetId,
  },
  {
    name: 'fileTypeID',
    title: 'FileType ID',
    getCellValue: (row: any) => row.fileTypeId,
  },
  {
    name: 'commandStatusTimestamp',
    title: 'Command Status Timestamp',
    getCellValue: (row: any) => row.commandStatusTimestamp,
  },
  {
    name: 'removedBy',
    title: 'Removed By',
    getCellValue: (row: any) => row.removedBy,
  },
  {
    name: 'replayCount',
    title: 'Resubmission Count',
    getCellValue: (row: any) => row.replayCount,
  },
  {
    name: 'transmissionToCatMQ',
    title: 'Sent to Endpoint',
    getCellValue: (row: any) => row.transmissionToCatMQ,
  },
  {
    name: 'lastResubmissionUserId',
    title: 'Last Resubmission User ID',
    getCellValue: (row: any) => row.lastResubmissionUserId,
  },
  {
    name: 'fileName',
    title: 'File Name / User ID',
    getCellValue: (row: any) => {
      if (row.isProtoParsingSupported === true && row.transactionType === "DATAFILE") {
        return "N/A"
      }
      if (row.createdBy && row.fileTypeName) {
        if (row.fileTypeName === row.createdBy) {
          return row.fileTypeName || 'N/A';
        }
        return `${row.fileTypeName} / ${row.createdBy}`;
      }
      return row.fileTypeName || 'N/A';
    },
  },
  {
    name: 'fileSize',
    title: 'File Size',
    getCellValue: (row: any) => row.fileSize,
  },
  {
    name: 'gatewayName',
    title: 'Source Gateway',
    getCellValue: (row: any) => row.gatewayName,
  },
  {
    name: 'region',
    title: 'Region',
    getCellValue: (row: any) => row.region || "N/A",
  },
];
